import { DatePicker, LocalizationProvider } from '@mui/lab';
import he from 'date-fns/locale/he';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Avatar, TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { setHours } from 'date-fns';
import { generateError, requiredMessage } from 'Regex';
import { CaseDetailsSlice, store } from '../../Store';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DatePickerIcon } from 'Images';

interface IControllerDatePicker {
  label?: string;
  name: string;
  viewYearOnly?: boolean;
  minDate?: Date;
  maxDate?: Date;
  required?: boolean;
  disabled?: boolean;
}
export const ControllerDatePicker = (innerProps: IControllerDatePicker) => {
  const {
    label,
    name,
    viewYearOnly = false,
    minDate = new Date('01/01/1900'),
    maxDate = new Date(),
    required = false,
    disabled,
  } = innerProps;

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    defaultValue: null,
    rules: {
      required: {
        value: required,
        message: requiredMessage,
      },
    },
  });

  const styleTextField = {
    '& .MuiOutlinedInput-root': {
      padding: 0,
      height: '40px',
      borderRadius: '6px',
      '& input': {
        height: '40px',
        padding: '0 14px',
        boxSizing: 'border-box',
        borderRadius: '6px',
        fontSize: '14px',
      },
    },
    '& fieldset': {
      borderColor: '#C6D3DB',
    },
    '& .MuiInputLabel-root': {
      top: '-6px',
      fontSize: '14px',
    },
    '& .MuiInputLabel-shrink': {
      top: 0,
    },
    '& .Mui-disabled': {
      backgroundColor: '#F5F5F5',
      color: '#60727E !important',
      '-webkit-text-fill-color': '#60727E !important',
    },
  };

  let { ref, value, onChange, onBlur, ...other } = field;

  const onInputBlur = () => {
    if (
      (value &&
        value.toString() ===
          Dictionary[DICTIONARY.GENERAL].errors.invalidDate) ||
      (maxDate && value > maxDate) ||
      (minDate && value < minDate)
    )
      onChange(undefined);

    onBlur();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={he}>
      <DatePicker
        onChange={(date) => {
          if (date) onChange(setHours(new Date(date), 3));
          else onChange(undefined);

          if (name == 'personalInfoSection.birthDate') {
            store.dispatch(
              CaseDetailsSlice.actions.setGeneralObj({ birthDate: date })
            );
          }
        }}
        mask={viewYearOnly ? '____' : '__/__/____'}
        inputFormat={viewYearOnly ? 'yyyy' : 'dd/MM/yyyy'}
        views={viewYearOnly ? ['year'] : undefined}
        inputRef={ref}
        {...other}
        label={label}
        value={value ? value : null}
        okText={Dictionary[DICTIONARY.GENERAL].select}
        cancelText={Dictionary[DICTIONARY.GENERAL].close}
        renderInput={(params) => (
          <TextField
            {...params}
            onBlur={onInputBlur}
            error={Boolean(error)}
            helperText={error?.message && generateError(label!, error?.message)}
            id={label}
            role={Boolean(error) ? 'alert' : undefined}
            sx={{
              ...styleTextField, // Applying custom styles
              ...(error?.type === 'isGray' && {
                '&  .MuiFormHelperText-root.MuiFormHelperText-filled.Mui-error':
                  {
                    backgroundColor: '#F8F8F8',
                    margin: 0,
                    padding: '3px 10px 0 10px',
                  },
              }),
            }}
          />
        )}
        components={{
          OpenPickerIcon: () => (
            <Avatar
              alt=''
              src={DatePickerIcon}
              sx={{ width: '17px', height: '19px', mr: 2 }}
            />
          ),
        }}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};
